import React, { useEffect, useState } from 'react';
import MobileMyStylistPage from './MobileMyStylistPage';
import DesktopMyStylistPage from './DesktopMyStylistPage';

const ResponsiveMyStylistPage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <MobileMyStylistPage /> : <DesktopMyStylistPage />;
};

export default ResponsiveMyStylistPage; 